(function () {
    class AlgoliaOpCustomSearch {
        constructor() {
            this.productsPerPage = Number(document.currentScript.dataset.itemsPerPage);
            this.template = document.currentScript?.dataset?.template || "collection";
            this.minResultsForBanners = parseInt(document.currentScript.dataset.minResultsForBanners) || 10;
            this.productsAdded = 0;
            this.firstPageRendered = false;
            this.totalRows = 0;
            this.fetchParams = undefined;
            this.loadMoreIndex = null;
            this.algoliaApiKey = window.algoliaShopify?.config?.search_api_key;
            this.algoliaAppId = window.algoliaShopify?.config?.app_id;
            this.facets = [];
            this.activeFacetsFilters = [];

            this.groupKeys = [];
            this.lastNbHits = 0;
            this.lastMaxHits = 0;
            this.firstPageHits = [];
            this.cardPromises = [];
            this.filteredFacetsMap = new Map();
            this.filteredResultCountMap = new Map();
            this.inflightRequests = new Map();
            this.lastFacetStr = "";
            this.lastFiltersEventSignature = "";
            this.lastFiltersEventAt = 0;
            this.notGroupedProductsCollection = window.collection.not_grouped;
            this.init();
        }
        
        static validateDateAnalytics(str) {
            if (!str) return '';
            
            return str
                .replace(/[^\w\s-]/g, '')
                .replace(/[\s_-]+/g, ' ')
                .trim()
                .split(' ')
                .map((word, index) => {
                if (index === 0) {
                    return word.toLowerCase();
                }
                return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
                })
                .join('');
        }


        getCurrentPage() {
            const url = new URL(window.location.href);
            const params = new URLSearchParams(url.search);
            const value = params.get('page');
            return Number(value);
        }

        waitForElement(selector, callback) {
            const target = document.querySelector("#MainContent") || document.body;
            const observer = new MutationObserver((_mutations, obs) => {
                if (document.querySelector(selector)) {
                    try {
                        callback.call(this);
                    } catch (e) {
                        console.error(e);
                    }
                    obs.disconnect();
                }
            });
            observer.observe(target, {childList: true, subtree: true});
        }

        getSort() {
            const template = document.querySelector("#op-algolia-sort-chip");
            this.originalSort = document.querySelector(".op-original-sort .ais-SortBy-select");
            if (!this.originalSort || !template || !this.sortOrders) return;
            this.sortOrders.forEach((sort, index) => {
                const clone = template.content.cloneNode(true);
                let originalOption = clone.querySelector('label');
                const div = document.createElement("div");
                div.innerHTML = originalOption.outerHTML
                    .replaceAll("[id]", sort.value)
                    .replaceAll("[name]", "op-sort-chip")
                    .replaceAll("[label]", sort.label);
                const radio = div.querySelector("input[type='radio']");
                radio.checked = index === 0;
                radio.addEventListener("change", () => {
                    this.originalSort.value = sort.value;
                    this.originalSort.dispatchEvent(new Event("change"));
                });
                document.querySelector(".op-sort-modal-wrapper")?.append(div);
            });
        }

        addBanners(page) {
            document.querySelectorAll(`template[id^="op-collection-banner"][data-render-page="${page}"]`).forEach(template => {
                if (template.dataset.cookie && !CookieUtils.getCookie(template.dataset.cookie)) return;
                const clone = template.content.cloneNode(true);
                const banner = clone.querySelector('.op-collection-banner')
                const style = document.createElement('style');
                const rowMobile = this.totalRows + Number(banner.dataset.rowMobile);
                const rowDesktop = this.totalRows + Number(banner.dataset.rowDesktop);

                style.innerHTML = `
                    #${banner.id} {
                        grid-row: ${rowMobile};
                    }
    
                    @media (min-width: 768px) {
                        #${banner.id} {
                            grid-row: ${rowDesktop};
                        }
                    }
                `;

                banner.append(style);

                banner.querySelectorAll(".js-op-modal-btn").forEach((btn) => {
                    btn.addEventListener("click", () => {
                        this.openOverlayByClick(btn);
                    });
                });

                document.querySelector(".ais-Hits-list").append(clone);
            })

            const computedStyle = window.getComputedStyle(document.querySelector(".ais-Hits-list"));
            const rows = computedStyle.getPropertyValue("grid-template-rows").split(" ");
            //this.totalRows = rows.length;

        }

        resetBanners() {
            document.querySelectorAll(".op-collection-banner").forEach(banner => {
                if (banner.tagName.toLowerCase() !== "template") {
                    banner.remove();
                }
            });

            this.totalRows = 0;
        }

        async fetchProductCard(handle, productCardFetchUrl, productSelector, trackSearchAttribution, index) {
            try {
                const response = await fetch(productCardFetchUrl);
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                
                const text = await response.text();
                const parser = new DOMParser();
                const doc = parser.parseFromString(text, 'text/html');
                const cardElement = doc.querySelector('#op-collection-product-card')?.firstElementChild;
                const productTitle = cardElement.querySelector('.tile-title')?.textContent.trim();

                if (!cardElement) return;

                trackSearchAttribution && 
                    cardElement.addEventListener("click", trackSearchAttribution);

                cardElement.setAttribute("data-template-name", this.template);
                document.querySelector(`#${productSelector}`)?.append(cardElement);

                if (this.template !== "search") return;

                const setupImageAnalytics = () => {
                    const imgWrappers = cardElement.querySelectorAll(
                        "[data-pd-image-wrapper], [data-pd-image-hover-wrapper]"
                    );
                    
                    if (!imgWrappers.length) return false;
                    
                    const productSku = cardElement
                        .querySelector(".op-algolia-product-card")
                        ?.dataset.firstVariantSku;
                    const description = `${AlgoliaOpCustomSearch.validateDateAnalytics(productTitle)}_${productSku}`;
                    const elementId = `Tiles_Tile_${index}`;
                    
                    for (const wrapper of imgWrappers) {
                        wrapper.setAttribute("data-element-id", elementId);
                        wrapper.setAttribute("data-description", description);
                    }
                    
                    return true;
                };

                // Observer con callback più pulita
                const observer = new MutationObserver(() => {
                    setupImageAnalytics() && observer.disconnect();
                });

                observer.observe(cardElement, { childList: true, subtree: true });
            } catch (error) {
                console.error('Error fetching product card:', error);

                // Remove product card if fetch fails
                document.querySelector(`#${productSelector}`)?.closest("li.ais-Hits-item")?.remove();
            } finally {
                this.productsAdded++;
                if (!this.firstPageRendered) {
                    this.firstPageRendered = true;

                    if (this.lastNbHits >= this.minResultsForBanners) {
                        this.addBanners(this.getCurrentPage() || 1);
                    }
                }
                document.dispatchEvent(new CustomEvent('la:dn:collection:updated'));
            }
        }

        openOverlayByClick(btn) {
            const modalId = btn.getAttribute("data-modal-id");
            const target = modalId ? document.getElementById(modalId) : null;
            if (target && typeof target.showModal === "function") {
                if (target.dataset.position === "right") target.classList.add('tw-animate-slide-left');
                target.showModal();
            }
        }

        onCardsLoaded () {
            Promise.allSettled(this.cardPromises).then(() => {
                this.showAisPage();
                this.cardPromises.length = 0;

                document.dispatchEvent(new CustomEvent('plp:cards-loaded', { detail: {
                    hits: this.firstPageHits,
                    maxHits: this.lastMaxHits
                } }));
            });
        }

        addProductCard(hit, trackSearchAttribution) {
            const productHandle = hit.handle;
            const productCardFetchUrl = `${Shopify.routes.root}products/${hit.handle}?view=op-product-card`;
            const timestamp = Date.now();
            const productSelector = `op-product-card-${hit.handle}-${hit.objectID}-${timestamp}`;

            const prom = this.fetchProductCard(productHandle, productCardFetchUrl, productSelector, trackSearchAttribution, hit.productPosition);
            this.cardPromises.push(prom);

            return `<div id="${productSelector}"></div>`;
        }

        setSearchLocalStorage() {
            const searchInput = document.currentScript?.dataset?.searchInput;
            if (!searchInput) return;
            const savedTerms = JSON.parse(localStorage.getItem("op-search-history") || "[]");
            const filteredTerms = [...new Set(savedTerms)].slice(0, 5);

            // Add the new search input to the beginning of the array
            filteredTerms.unshift(searchInput);
            const uniqueTerms = [...new Set(filteredTerms)];

            localStorage.setItem("op-search-history", JSON.stringify(uniqueTerms));
        }

        // ---- NEW: helper to format facet filters as a string for Tealium ----
        formatFacetFiltersToString(facetFilters = []) {
            return (facetFilters || [])
                .map((f) =>
                    Array.isArray(f)
                        ? f.map((i) => String(i).replace(":", "=")).join(",")
                        : String(f).replace(":", "=")
                )
                .join("|");
        }

        // ---- Networking helpers ----
        getQueryUrl() {
            const url = new URL(`//${this.algoliaAppId}-dsn.algolia.net/1/indexes/*/queries`, window.location.origin);
            url.searchParams.set("x-algolia-api-key", this.algoliaApiKey);
            url.searchParams.set("x-algolia-application-id", this.algoliaAppId);
            return url;
        }

        fetchAlgoliaRequests(requests = []) {
            const url = this.getQueryUrl();
            const body = JSON.stringify({ requests });
            const requestKey = `${url.toString()}::${body}`;

            if (this.inflightRequests.has(requestKey)) {
                return this.inflightRequests.get(requestKey);
            }

            const requestPromise = fetch(url, {
                body,
                method: "POST",
            })
                .then((response) => response.json())
                .finally(() => {
                    this.inflightRequests.delete(requestKey);
                });

            this.inflightRequests.set(requestKey, requestPromise);
            return requestPromise;
        }

        getLastIndexName() {
            return (
                window.algoliaShopify?.instantsearch?.search?.helper?.lastResults?.index ||
                "shopify_products"
            );
        }

        loadFilteredProducts(facets, facetFilters, indexName) {
            const params = new URLSearchParams(this.fetchParams);

            if (facetFilters?.length > 0) {
                params.set("facetFilters", JSON.stringify(facetFilters));
            } else {
                params.delete("facetFilters");
            }

            if (facets?.length > 0) {
                params.set("facets", JSON.stringify(facets));
            } else {
                params.delete("facets");
            }

            const req = {
                indexName: indexName || this.getLastIndexName(),
                params: params.toString(),
            }

            this.fetchParams = req.params;
            this.loadMoreIndex = req.indexName;
            this.activeFacetsFilters = facetFilters || [];

            this.showLoader();
            this.resetBanners();
            this.firstPageRendered = false;
            this.productsAdded = 0;

            this.fetchAlgoliaRequests([req])
                .then((data) => {
                    const result = data.results?.[0];
                    const hitsListEl = document.querySelector(".ais-Hits-list");

                    if (!result) {
                        console.error("No results found for the given query.");
                        this.showNoResults();
                        return;
                    }

                    if (!hitsListEl) {
                        console.error("Hits list element not found. Result data:", result);
                        return;
                    }

                    hitsListEl.querySelectorAll(".ais-Hits-item").forEach(item => item.remove());
                    this.groupKeys.length = 0;

                    const totalProductsCount = document.querySelector(".op-total-products-quantity");
                    if (totalProductsCount) totalProductsCount.textContent = result.nbHits;

                    result.hits.forEach((hit) => {
                        const gkey = hit.meta?.custom?.x_groupkey;
                        const li = document.createElement("li");
                        li.classList.add("ais-Hits-item");
                        li.innerHTML = this.addProductCard(hit);
                        hitsListEl.append(li);
                        if (gkey && !this.groupKeys.includes(gkey)) this.groupKeys.push(gkey);
                    });

                    this.maxPages = result.nbPages;
                    this.lastNbHits = Math.min(result.nbHits, this.productsPerPage);

                    if (result.nbHits === 0) {
                        this.showNoResults();
                    } else if (this.groupKeys.length > 0) {
                        this.loadProductGroups(this.groupKeys, req.indexName);
                    } else {
                        this.showAisPage();
                    }

                    document.dispatchEvent(new CustomEvent("plp:filters-hits", {detail: this.groupKeys}));
                    this.sendTealiumData(result);
                })
                .catch(error => console.error('Error fetching Algolia data:', error));
        }

        loadFilteredPreview(facets, facetFilters, indexName) {
            const normalizedFacetFilters = Array.isArray(facetFilters) ? facetFilters : [];
            const hasFilters = normalizedFacetFilters.length > 0;
            const rawFilters = JSON.stringify(normalizedFacetFilters);
            const cachedFacetResults = this.filteredFacetsMap.get(rawFilters);
            const hasCachedFacetResults = Boolean(cachedFacetResults) || !hasFilters;
            const cachedCount = hasFilters ? this.filteredResultCountMap.get(rawFilters) : this.lastMaxHits;
            const hasCachedCount = typeof cachedCount === "number";

            if (hasCachedFacetResults) {
                this.dispatchFacetsUpdated(cachedFacetResults, true);
            }

            if (hasCachedCount) {
                document.dispatchEvent(new CustomEvent("plp:facet-count-updated", {detail: {nbHits: cachedCount}}));
            }

            if (hasCachedFacetResults && hasCachedCount) {
                return;
            }

            const activeIndexName = indexName || this.getLastIndexName();
            const requests = [];
            const facetRequestCount = hasCachedFacetResults ? 0 : normalizedFacetFilters.length;
            const requestIndexes = new Map();

            if (!hasCachedFacetResults) {
                for (const filter of normalizedFacetFilters) {
                    const params = new URLSearchParams(this.fetchParams);

                    if (facets && facets.length > 0) {
                        params.set("facets", JSON.stringify(facets));
                    } else {
                        params.delete("facets");
                    }

                    params.set("facetFilters", JSON.stringify([filter]));
                    params.set("hitsPerPage", "0");

                    const request = {
                        indexName: activeIndexName,
                        params: params.toString(),
                    };

                    requestIndexes.set(`${request.indexName}::${request.params}`, requests.length);
                    requests.push(request);
                }
            }

            let countRequestIndex = -1;

            if (!hasCachedCount) {
                const params = new URLSearchParams(this.fetchParams);
                params.set("facets", JSON.stringify(facets || []));
                params.set("facetFilters", rawFilters);
                params.set("hitsPerPage", "0");

                const countRequest = {
                    indexName: activeIndexName,
                    params: params.toString(),
                };
                const requestKey = `${countRequest.indexName}::${countRequest.params}`;

                if (requestIndexes.has(requestKey)) {
                    countRequestIndex = requestIndexes.get(requestKey);
                } else {
                    countRequestIndex = requests.length;
                    requests.push(countRequest);
                }
            }

            if (requests.length === 0) {
                return;
            }

            this.fetchAlgoliaRequests(requests)
                .then((data) => {
                    const results = Array.isArray(data.results) ? data.results : [];

                    if (!hasCachedFacetResults) {
                        const facetResults = results.slice(0, facetRequestCount);

                        if (facetResults.length === 0) {
                            console.warn("No results found for filtered facets. Req:", requests);
                        }

                        this.dispatchFacetsUpdated(facetResults, false);
                        this.filteredFacetsMap.set(rawFilters, facetResults);
                    }

                    if (!hasCachedCount) {
                        const nbHits = results[countRequestIndex]?.nbHits || 0;
                        document.dispatchEvent(new CustomEvent("plp:facet-count-updated", {detail: {nbHits}}));

                        if (hasFilters) {
                            this.filteredResultCountMap.set(rawFilters, nbHits);
                        }
                    }
                })
                .catch(error => console.error('Error fetching Algolia data:', error));
        }

        loadProductGroups(xGroupKeys = [], indexName = null) {
            const requests = xGroupKeys.map((key) => {
                let params = new URLSearchParams({
                    facetFilters: JSON.stringify([`meta.custom.x_groupkey:${key}`, ...this.activeFacetsFilters]),
                    facets: JSON.stringify(["meta.custom.x_groupkey"]),
                });

                params.set("clickAnalytics", "true");
                
                if(window.collection?.products_count && window.collection.products_count != 0) {
                        params.set("hitsPerPage", window.collection.products_count);
                }

                // remove parameters (meta.custom.x_groupkey) if collection unpacked
                if (this.notGroupedProductsCollection == true) {
                        params = "";
                }

                const req = {       
                    indexName: indexName || this.getLastIndexName(),
                    params: params.toString(),
                }

                return req;
            });

            this.fetchAlgoliaRequests(requests)
                .then(data => {
                    const groups = [];

                    for (const result of data.results) {
                        if (result.hits.length > 0) {
                            groups.push({
                                xGroupKey: result.hits[0].meta?.custom?.x_groupkey,
                                hits: this.filterHits(result.hits),
                            });
                        }
                    }

                    if (this.facets.length === 0) {
                        this.facets = window.algoliaShopify?.instantsearch?.search?.helper?.lastResults?.facets || [];
                    }

                    sessionStorage.setItem("lastPLPGroups", JSON.stringify(groups));
                    document.dispatchEvent(new CustomEvent("plp:groups-loaded", {detail: groups}));

                    document.dispatchEvent(new CustomEvent("plp:facets-loaded", {
                        detail: {
                            facets: this.facets,
                            nbHits: this.lastNbHits,
                            maxHits: this.lastMaxHits,
                            showResults: true,
                            facetOrdering: data.results[0].renderingContent.facetOrdering.facets.order  
                        }
                    }));

                    if (this.cardPromises.length > 0) {
                        this.onCardsLoaded();
                    }
                })
                .catch(error => console.error('Error fetching Algolia data:', error));
        }

        filterHits(hits = []) {
            const handleSet = new Set();
            const filteredHits = [];

            for (const hit of hits) {
                if (!handleSet.has(hit.handle)) {
                    filteredHits.push({
                        handle: hit.handle,
                        id: hit.id,
                        image: hit.image,
                        inventory_available: hit.inventory_available,
                        objectID: hit.objectID,
                        title: hit.title,
                        collections: hit.collections || [],
                        queryID: hit.queryID || "",
                    });
                    handleSet.add(hit.handle);
                }
            }

            return filteredHits;
        }

        dispatchFacetsUpdated(results, cached) {
            document.dispatchEvent(new CustomEvent("plp:facets-updated", {
                detail: {results, cached}
            }));
        }

        showAisPage() {
            const aisPage = document.querySelector(".ais-page");
            const opPulsingLogo = document.querySelector(".op-pulsing-logo");

            if (opPulsingLogo) {
                opPulsingLogo.toggleAttribute("data-loaded", true);

                if (this.lastNbHits > 0) {
                    opPulsingLogo.style.display = "none";
                }
            }

            if (aisPage) {
                aisPage.style.display = "block";
                aisPage.style.visibility = "visible";
                aisPage.style.minHeight = "";
            }
        }

        showLoader() {
            const aisPage = document.querySelector(".ais-page");
            const opPulsingLogo = document.querySelector(".op-pulsing-logo");

            if (opPulsingLogo) {
                opPulsingLogo.toggleAttribute("data-loaded", false);
                opPulsingLogo.style.removeProperty("display");
            }

            if (aisPage) {
                // aisPage.style.display = "none";
                aisPage.style.visibility = "hidden";
                aisPage.style.minHeight = aisPage.offsetHeight + "px";

                aisPage.classList.remove("ais-Hits--empty");
                aisPage.querySelector(".ais-hit-empty")?.remove();
                aisPage.querySelector(".ais-Hits-list")?.style.removeProperty("display");
            }
        }

        showNoResults() {
            const aisHits = document.querySelector(".ais-page .ais-Hits");
            const translations = window.algoliaShopify?.translations;
            const container = document.querySelector(".ais-hit-empty") || document.createElement("div");
            const hitList = document.querySelector(".ais-Hits-list");

            if (aisHits && translations) {
                aisHits.classList.add("ais-Hits--empty");

                container.innerHTML = `
                    <div class="ais-hit-empty">
                        <div class="ais-hit-empty--title tw-font-heading">
                          ${translations.noResultFound}
                        </div>
                        <div class="ais-hit-empty--clear tw-font-heading">
                          ${translations.try}
                          <a class="ais-hit-empty--clear-filters ais-link tw-font-heading">
                            ${translations.clearFilters}
                          </a>
                          ${translations.or}
                          <a class="ais-hit-empty--clear-input ais-link tw-font-heading">
                            ${translations.changeInput}
                          </a>
                        </div>
                    </div>
                `;

                container.querySelector(".ais-hit-empty--clear-filters")?.addEventListener("click", () => {
                    document.dispatchEvent(new CustomEvent("plp:clear-filters"));
                });

                container.querySelector(".ais-hit-empty--clear-input")?.addEventListener("click", () => {
                    document.dispatchEvent(new CustomEvent("plp:open-filters"));
                });

                aisHits.append(container);
            }

            if (hitList) hitList.style.display = "none";

            this.showAisPage();
        }

        // ---- Tealium ----
        sendTealiumData = (data) => {
            if (!window.tealium_data2track || typeof window.tealium_data2track.push !== "function") {
                console.warn("Tealium data tracking function is not defined.");
                return;
            }

            const lastParams = data.params || window.algoliaShopify?.instantsearch?.search?.helper?.lastResults?.params;
            let parsedParams = [];

            try {
                const fetchParams = String(lastParams || "")
                    .split("&")
                    .filter((param) => param.includes("facetFilters"));
                const decoded = decodeURIComponent(fetchParams[0] || "");
                parsedParams = fetchParams[0] ? JSON.parse(decoded.split("=")[1]) : [];
            } catch (e) {
                console.error("Error parsing facet filters from params:", e);
            }

            // const facetStr = this.formatFacetFiltersToString(parsedParams);
            // const tealiumData = {
            //     id: "SearchFilterUpdated",
            //     Search_ResultItemsQnt: `${data.nbHits || 0}`,
            //     Events_SearchFiltering: "1",
            //     Search_FacetValues_String: facetStr,
            //     Search_Keyword: data.query || "",
            // }

            tealiumData.Events_SearchRun = this.template === "search" ? "1" : "0";
            tealiumData.Search_Type = typeof data.query === "string" ? "text" : "";
            tealiumData.Search_View = this.template === "search" ? "SERP" : "";
            tealiumData.Search_ResultItemsQnt = data.nbHits || 0;
            window.tealium_data2track.push(tealiumData);
        };

        init() {
            document.addEventListener("algolia.hooks.initialize", () => {
                // beforeInstantSearchConfigurationOptions
                window.algoliaShopify?.hooks?.registerHook(
                    "beforeInstantSearchConfigurationOptions",
                    (options) => {
                        return {
                            ...options,
                            searchFunction: (searchFunctionHelper) => {
                                const requestedPage = this.getCurrentPage() || 1;
                                const page = requestedPage > 1 ? 0 : searchFunctionHelper.getPage();
                                if (this.template === "collection") {
                                    const collectionHandle = window.collection.plp_handle;
                                    const dynamicRuleContexts = sessionStorage.getItem('ruleContexts');

                                    // if collection have metafield true, "distinct" parameter not need to use
                                    if(this.notGroupedProductsCollection == false) {
                                     searchFunctionHelper.setQueryParameter("distinct", true);
                                    }
                                    
                                    searchFunctionHelper.setQueryParameter("ruleContexts", [
                                        "shopify_default_collection",
                                            ...(this.notGroupedProductsCollection ? ["upc_collapsed"] : []),
                                        "grouped",
                                        collectionHandle,
                                        dynamicRuleContexts ? JSON.parse(dynamicRuleContexts) : ""
                                    ]);
                                    searchFunctionHelper.setQueryParameter(
                                        "filters",
                                        "collections:" + collectionHandle
                                    );
                                } else {
                                    searchFunctionHelper.setQueryParameter("ruleContexts", [
                                        "upc_collapsed"
                                    ]);
                                }
                                searchFunctionHelper.setPage(page);
                                searchFunctionHelper.search();
                            },
                        };
                    }
                );

                // beforeInstantSearchProductTemplate
                window.algoliaShopify?.hooks?.registerHook(
                    "beforeInstantSearchProductTemplate",
                    (_defaultTemplate, hit, trackSearchAttribution) => {
                        const groupKey = hit?.meta?.custom?.x_groupkey;
                        this.fetchParams =
                            window.algoliaShopify?.instantsearch?.search?.helper?.lastResults?.params;
                        this.firstPageHits.push(hit);

                        const setClickAttribution = () => trackSearchAttribution(hit);

                        if (groupKey && !this.groupKeys.includes(groupKey)) this.groupKeys.push(groupKey);

                        const prodCard = this.addProductCard(hit, setClickAttribution);

                        if (this.firstPageHits.length === this.lastNbHits) {
                            if (this.groupKeys.length > 0) {
                                this.loadProductGroups(this.groupKeys);
                            } else {
                                this.onCardsLoaded();
                            }
                        }
                        return prodCard;
                    }
                );

                // Main/No Result templates
                window.algoliaShopify?.hooks?.registerHook(
                    "beforeInstantSearchMainTemplate",
                    (_defaultTemplate, data, html) => {
                        return html`
                            <div id="op-algolia-header-wrapper"></div>
                            <div class="ais-page" style="display: none;">
                                <div class="ais-input" style="display: none;">
                                    <div class="ais-search-box-container"></div>
                                    <div class="ais-input-button">
                                        <div class="ais-clear-input-icon"></div>
                                    </div>
                                </div>
                                <div class="ais-facets-button" style="display: none;">Show filters</div>
                                <div class="filters-wrapper" style="display: none">
                                    <div class="ais-clear-refinements-container"></div>
                                    <div class="ais-current-refined-values-container"></div>
                                    <div class="
                    ais-dynamic-widgets-container [&_.ais-Panel:not(hidden)]:tw-border-t-1
                    [&_.ais-Panel:not(hidden)]:tw-py-op-spacings-lg [&_.ais-Panel]:tw-border-neutral-lighter
                    [&_label]:tw-font-heading [&_label]:tw-text-[16px]">
                                    </div>
                                </div>
                                <div>
                                    <div class="ais-search-header" style="display: none;">
                                        <div class="ais-stats-container"></div>
                                        <div class="ais-change-display">
                      <span class="ais-change-display-block ais-change-display-selected">
                        <i class="fa fa-th-large"></i>
                      </span>
                                            <span class="ais-change-display-list">
                        <i class="fa fa-th-list"></i>
                      </span>
                                        </div>
                                        <div class="ais-sort op-original-sort">
                                            ${data.multipleSortOrders
                                                    ? html`${window.algoliaShopify.translations.sortBy}
                                                    <span class="ais-sort-orders-container"></span>`
                                                    : html`${window.algoliaShopify.translations.sortBy}
                                                    ${window.algoliaShopify.translations.relevance}`}
                                        </div>
                                    </div>
                                    <div class="ais-hits-container ais-results-as-block"></div>
                                </div>
                                <div class="ais-pagination-container"></div>
                            </div>
                        `;
                    }
                );

                window.algoliaShopify?.hooks?.registerHook(
                    "beforeInstantSearchNoResultTemplate",
                    (_defaultTemplate, html) => {
                        this.showAisPage();

                        // set span in japan market 
                        // jp not need link for clear filters and change input
                        const lang = document.documentElement.lang;
                        const useSpan = lang === "ja-JP" || lang === "en-JP";

                        const ClearFilters = useSpan
                        ? html`<span class="ais-hit-empty--clear-filters tw-font-heading">${window.algolia.translations.clearFilters}</span>`
                        : html`<a class="ais-hit-empty--clear-filters tw-font-heading">${window.algolia.translations.clearFilters}</a>`;

                        const ChangeInput = useSpan
                        ? html`<span class="ais-hit-empty--clear tw-font-heading">${window.algolia.translations.changeInput}</span>`
                        : html`<a class="ais-hit-empty--clear tw-font-heading">${window.algolia.translations.changeInput}</a>`;
                        // set html template no resultss
                        return html`
                            <div class="ais-hit-empty">
                                <div class="ais-hit-empty--title tw-font-heading">
                                    ${window.algolia.translations.noResultFound}
                                </div>
                                <div class="ais-hit-empty--clear tw-font-heading">
                                    ${window.algolia.translations.try}
                                    ${ClearFilters}
                                    ${window.algolia.translations.or}
                                    ${ChangeInput}
                                </div>
                            </div>
                        `;
                    }
                );

                // Stats template - update counters and push to Tealium (existing behavior)
                window.algoliaShopify?.hooks?.registerHook(
                    "beforeInstantSearchStatsTemplate",
                    (_defaultTemplate, data) => {
                        this.maxPages = data.nbPages;
                        this.lastNbHits = Math.min(data.nbHits, this.productsPerPage);
                        this.lastMaxHits = data.nbHits;
                        this.groupKeys.length = 0;

                        const totalProductsCount = document.querySelector(".op-total-products-quantity");
                        const totalArticlesCount = document.querySelector(".op-total-articles-quantity");
                        if (totalProductsCount) totalProductsCount.textContent = data.nbHits;

                        setTimeout(() => {
                            this.sendTealiumData(data);
                        }, 500);

                        if (data.nbHits === 0) {
                            totalProductsCount?.classList.add("tw-hidden");
                        } else {
                            totalArticlesCount?.classList.add("tw-hidden");
                        }
                    }
                );
            });

            // ---- Local storage for search term ----
            this.setSearchLocalStorage();

            // ---- Filters change handler ----
            document.addEventListener("plp:filters-changed", (event) => {
                const {selFacets, facetsFilters, index, showResults, tealiumFacets, sendTealiumData} = event.detail || {};
                const eventSignature = JSON.stringify({ selFacets, facetsFilters, index, showResults });
                const now = Date.now();

                if (
                    eventSignature === this.lastFiltersEventSignature &&
                    now - this.lastFiltersEventAt < 250
                ) {
                    return;
                }

                this.lastFiltersEventSignature = eventSignature;
                this.lastFiltersEventAt = now;

                const facetStr = this.formatFacetFiltersToString(tealiumFacets || []);
                this.lastFacetStr = facetStr;

                // --- TEALIUM: track filters changed (immediately) ---
                if (sendTealiumData) {
                    try {
                        const query =
                            window.algoliaShopify?.instantsearch?.search?.helper?.state?.query || "";

                        const cachedCount = this.filteredResultCountMap.get(
                            JSON.stringify(facetsFilters || "[]")
                        );
                        const resultItemsQnt = String(cachedCount ?? this.lastMaxHits ?? 0);
                        if (typeof window.tealium_data2track?.push === "function") {
                            window.tealium_data2track.push({
                                id: "Event",
                                Search_ResultItemsQnt: resultItemsQnt,
                                Events_SearchFiltering: "1",
                                Search_FacetValues_String: facetStr,
                                Search_Keyword: query,
                            });
                        }
                        this.lastFacetStr = "";
                    } catch (e) {
                        console.warn("Tealium push on filters-changed failed:", e);
                    }
                }

                if (showResults) {
                    this.loadFilteredProducts(selFacets, facetsFilters, index);
                } else {
                    this.loadFilteredPreview(selFacets, facetsFilters, index);
                }
            });

            // ---- When facet count is updated, push definitive count to Tealium ----
            // document.addEventListener("plp:facet-count-updated", (e) => {
            //     try {
            //         const nbHits = e?.detail?.nbHits ?? 0;
            //         const query =
            //             window.algoliaShopify?.instantsearch?.search?.helper?.state?.query || "";
            //         const facetStr =
            //             this.lastFacetStr ||
            //             this.formatFacetFiltersToString(
            //                 JSON.parse(
            //                     window.algoliaShopify?.instantsearch?.search?.helper?.state?.facetFilters ||
            //                     "[]"
            //                 )
            //             );
            //         if (typeof window.tealium_data2track?.push === "function") {
            //             window.tealium_data2track.push({
            //                 id: "SearchFilterUpdated",
            //                 Search_ResultItemsQnt: String(nbHits),
            //                 Events_SearchFiltering: "1",
            //                 Search_FacetValues_String: facetStr,
            //                 Search_Keyword: query,
            //             });
            //         }
            //     } catch (err) {
            //         console.warn("Tealium push on facet-count-updated failed:", err);
            //     }
            // });

            // ---- Header/filters UI setup (existing) ----
            this.waitForElement("#algolia-shopify-instantsearch", () => {
                const wrapper = document.querySelector("#op-algolia-header-wrapper");
                const template = document.querySelector("#op-algolia-collection-header");
                if (wrapper && template) {
                    const clone = document.importNode(template.content, true);
                    const cloneContent = clone.querySelector("div");
                    wrapper.replaceWith(cloneContent);
                    const filterButtonWrapper = cloneContent.querySelector("op-modal-trigger");
                    const websiteHeader =
                        document.querySelector(".js-headerGroup") ||
                        document.getElementById("op-main-header-fixed");

                    const observer = new IntersectionObserver(function (entries) {
                        entries.forEach((entry) => {
                            const staticTrigger = this.querySelector('[data-filter-static]');
                            const fixedTrigger = this.querySelector('[data-filter-fixed]');
                            const filterButton = filterButtonWrapper?.querySelector("button");

                            if (!staticTrigger || !fixedTrigger || !filterButton) return;

                            if (entry.isIntersecting) {
                                staticTrigger.classList.remove("tw-hidden");
                                fixedTrigger.classList.add("tw-hidden");
                                filterButton.classList.remove("tw-shadow-md");
                            } else if (websiteHeader) {
                                fixedTrigger.classList.remove("tw-hidden");
                                staticTrigger.classList.add("tw-hidden");
                                filterButton.classList.add("tw-shadow-md");
                            }
                        });
                    }.bind(cloneContent));

                    observer.observe(document.querySelector(".op-custom-algolia-header"));

                    document
                        .querySelector(".op-filters-modal-wrapper")
                        ?.append(document.querySelector(".filters-wrapper"));
                    const filtersWrapper = document.querySelector(".filters-wrapper");
                    if (filtersWrapper) filtersWrapper.style.display = "block";
                    this.getSort();
                }
            });
        }
    }

    const algoliaOpCustomSearch = new AlgoliaOpCustomSearch();

    if (!customElements.get('op-load-more-algolia')) {
        class OpLoadMoreCollection extends HTMLElement {
            constructor() {
                super();
                this.isLoading = false;
                this.hasHydratedInitialPages = false;
                this.historySyncTimers = [];
                this.handleAlgoliaRender = this.handleAlgoliaRender.bind(this);
                this.handleLoadMore = this.handleLoadMore.bind(this);
                this.handleFiltersHits = this.handleFiltersHits.bind(this);
            }

            connectedCallback() {
                this.button = this.querySelector('.js-load-more');
                this.paginationWrapper = this.querySelector('[data-load-more-pagination]');
                this.currentPage = this.getCurrentPage();

                this.updateHistory(this.currentPage);
                this.queueHistorySync();
                this.syncControlState();

                document.addEventListener('algolia.instantSearch.onRender', this.handleAlgoliaRender);
                document.addEventListener("plp:filters-hits", this.handleFiltersHits);
                this.button?.addEventListener("click", this.handleLoadMore);
            }

            disconnectedCallback() {
                this.clearHistorySyncTimers();
                document.removeEventListener('algolia.instantSearch.onRender', this.handleAlgoliaRender);
                document.removeEventListener("plp:filters-hits", this.handleFiltersHits);
                this.button?.removeEventListener("click", this.handleLoadMore);
            }

            handleAlgoliaRender() {
                this.updateHistory(this.currentPage);
                this.queueHistorySync();

                if (this.shouldHydrateInitialPages()) {
                    this.hydrateInitialPages();
                    return;
                }

                this.syncControlState();
                this.setBtnHidden(this.currentPage >= algoliaOpCustomSearch.maxPages);
                this.updateHistory(this.currentPage);
            }

            handleLoadMore(event) {
                event.preventDefault();
                if (this.isLoading || this.currentPage >= algoliaOpCustomSearch.maxPages) return;

                this.setLoading(true);

                this.fetchAlgoliaData(this.currentPage).then((loaded) => {
                    if (!loaded) return;

                    this.currentPage += 1;
                    this.updateHistory(this.currentPage);
                    this.queueHistorySync();
                    this.syncControlState();
                    this.setBtnHidden(this.currentPage >= algoliaOpCustomSearch.maxPages);
                }).finally(() => {
                    this.setLoading(false);
                });
            }

            handleFiltersHits() {
                this.hasHydratedInitialPages = false;
                this.currentPage = 1;
                this.updateHistory(this.currentPage);
                this.queueHistorySync();
                this.syncControlState();
                this.setBtnHidden(this.currentPage >= algoliaOpCustomSearch.maxPages);
            }

            shouldHydrateInitialPages() {
                return !this.hasHydratedInitialPages
                    && !this.isLoading
                    && this.currentPage > 1
                    && Boolean(algoliaOpCustomSearch.fetchParams);
            }

            hydrateInitialPages() {
                this.hasHydratedInitialPages = true;
                this.setLoading(true);

                this.fetchPagesUntilCurrentPage().then((loaded) => {
                    if (!loaded) {
                        this.hasHydratedInitialPages = false;
                        return;
                    }

                    this.updateHistory(this.currentPage);
                    this.queueHistorySync();
                    this.syncControlState();
                    this.setBtnHidden(this.currentPage >= algoliaOpCustomSearch.maxPages);
                }).finally(() => {
                    this.setLoading(false);
                });
            }

            async fetchPagesUntilCurrentPage() {
                for (let pageNumber = 1; pageNumber < this.currentPage; pageNumber++) {
                    const loaded = await this.fetchAlgoliaData(pageNumber);
                    if (!loaded) {
                        return false;
                    }
                }

                return true;
            }

            getCurrentPage() {
                const page = algoliaOpCustomSearch.getCurrentPage() || Number(this.dataset.currentPage) || 1;
                return page > 0 ? page : 1;
            }

            getPageUrl(pageNumber) {
                const nextUrl = new URL(window.location.href);
                if (pageNumber > 1) {
                    nextUrl.searchParams.set("page", pageNumber.toString());
                } else {
                    nextUrl.searchParams.delete("page");
                }
                return `${nextUrl.pathname}${nextUrl.search}${nextUrl.hash}`;
            }

            getCanonicalUrl(pageNumber) {
                const canonicalUrl = new URL(this.getPageUrl(pageNumber), window.location.origin);
                return `${canonicalUrl.origin}${canonicalUrl.pathname}${canonicalUrl.search}`;
            }

            updateCanonical(pageNumber) {
                const canonicalLink = document.querySelector('link[rel="canonical"]');

                if (!canonicalLink) {
                    return;
                }

                canonicalLink.href = this.getCanonicalUrl(pageNumber);
            }

            updateHistory(pageNumber) {
                const nextUrl = this.getPageUrl(pageNumber);
                const currentUrl = `${window.location.pathname}${window.location.search}${window.location.hash}`;

                this.updateCanonical(pageNumber);

                if (currentUrl === nextUrl) return;

                history.replaceState({ page: pageNumber }, "", nextUrl);
            }

            clearHistorySyncTimers() {
                this.historySyncTimers.forEach((timerId) => clearTimeout(timerId));
                this.historySyncTimers = [];
            }

            queueHistorySync() {
                this.clearHistorySyncTimers();

                [0, 50, 150, 300, 600].forEach((delay) => {
                    const timerId = setTimeout(() => {
                        this.updateHistory(this.currentPage);
                    }, delay);

                    this.historySyncTimers.push(timerId);
                });
            }

            syncControlState() {
                const nextPage = this.currentPage + 1;
                const nextPageUrl = this.getPageUrl(nextPage);

                this.dataset.currentPage = this.currentPage.toString();
                this.dataset.nextPage = nextPage.toString();

                if (this.paginationWrapper) {
                    this.paginationWrapper.dataset.page = nextPage.toString();
                    this.paginationWrapper.dataset.pageUrl = nextPageUrl;
                }

                if (this.button) {
                    this.button.dataset.page = nextPage.toString();
                    if (this.button.tagName === "A") {
                        this.button.href = nextPageUrl;
                    }
                }
            }

            setLoading(isLoading) {
                this.isLoading = isLoading;

                if (this.button) {
                    this.button.setAttribute("aria-disabled", isLoading ? "true" : "false");
                    this.button.style.pointerEvents = isLoading ? "none" : "";
                    this.button.style.opacity = isLoading ? "0.6" : "";
                }
            }

            setBtnHidden(hide) {
                const target = this.paginationWrapper || this.button;

                if (target) {
                    hide ? target.style.display = "none" : target.style.removeProperty("display");
                }
            }

            fetchAlgoliaData(pageNumber) {
                const url = new URL(`//${algoliaOpCustomSearch.algoliaAppId}-dsn.algolia.net/1/indexes/*/queries`, window.location.origin);

                if (!algoliaOpCustomSearch.fetchParams) {
                    console.error("No fetch params found");
                    return Promise.resolve(false);
                }

                url.searchParams.set("x-algolia-api-key", algoliaOpCustomSearch.algoliaApiKey);
                url.searchParams.set("x-algolia-application-id", algoliaOpCustomSearch.algoliaAppId);

                const requestParams = algoliaOpCustomSearch.fetchParams.includes("page=")
                    ? algoliaOpCustomSearch.fetchParams.replace(/page=\d+/, `page=${pageNumber}`)
                    : `${algoliaOpCustomSearch.fetchParams}${algoliaOpCustomSearch.fetchParams ? "&" : ""}page=${pageNumber}`;

                const req = {
                    indexName: algoliaOpCustomSearch.loadMoreIndex || algoliaOpCustomSearch.getLastIndexName(),
                    params: requestParams
                }

                const body = JSON.stringify({
                    requests: [req]
                });

                return fetch(url, {body, method: "POST"})
                    .then(response => response.json())
                    .then(data => {
                        const groupKeys = [];

                        data.results[0].hits.forEach(hit => {
                            const groupKey = hit.meta?.custom?.x_groupkey;
                            const div = algoliaOpCustomSearch.addProductCard(hit);
                            const li = document.createElement('li');
                            li.classList.add('ais-Hits-item');
                            li.innerHTML = div;
                            document.querySelector(".ais-Hits-list")?.append(li);

                            if (groupKey && !groupKeys.includes(groupKey)) {
                                groupKeys.push(groupKey);
                            }
                        });

                        algoliaOpCustomSearch.addBanners(pageNumber + 1);

                        if (groupKeys.length > 0) {
                            algoliaOpCustomSearch.loadProductGroups(groupKeys, req.indexName);
                        }

                        return true;
                    })
                    .catch(error => {
                        console.error('Error:', error);
                        return false;
                    });
            }


        }

        customElements.define("op-load-more-algolia", OpLoadMoreCollection);
    }
})();
